import React from 'react';
import { motion } from 'framer-motion';

function rateClass(r) {
  if (r === null || r === undefined) return 'neutral';
  if (r >= 90) return 'ok';
  if (r >= 60) return 'warn';
  return 'bad';
}

function getMgrStats(mgr, brands, getMonthRecord, month) {
  const mb = brands.filter(b => b.managerId === mgr.id);
  let cpD=0, cpC=0, rep=0, tp=0, target=0, pending=0;
  mb.forEach(b => {
    const r = getMonthRecord(b.id, month);
    if (r.contentPlanToDesigner) cpD++;
    if (r.contentPlanToClient)   cpC++;
    if (r.monthlyReportSent)     rep++;
    const d = r.deliverables||{};
    tp += (d.w1Posts||0)+(d.w2Posts||0)+(d.w3Posts||0)+(d.w4Posts||0);
    target += b.targetPosts||0;
    pending += (r.tasks||[]).filter(t => t.status!=='done' && t.status!=='cancelled').length;
  });
  const n = mb.length;
  const pr = target > 0 ? Math.round((tp/target)*100) : null;
  return {
    n, cpD, cpC, rep, pending, postRate: pr,
    cpDRate: n ? Math.round((cpD/n)*100) : 0,
    cpCRate: n ? Math.round((cpC/n)*100) : 0,
    repRate: n ? Math.round((rep/n)*100) : 0,
  };
}

const container = { animate: { transition: { staggerChildren: 0.06 } } };
const item = { initial: { opacity:0, y:20 }, animate: { opacity:1, y:0, transition:{ duration:.3, ease:[.4,0,.2,1] } } };

export default function Overview({ store, navigate }) {
  const { state, getMonthRecord } = store;
  const { managers, brands, currentMonth } = state;
  const month = currentMonth;

  let allCpD=0, allCpC=0, allRep=0, allPending=0;
  brands.forEach(b => {
    const r = getMonthRecord(b.id, month);
    if (r.contentPlanToDesigner) allCpD++;
    if (r.contentPlanToClient)   allCpC++;
    if (r.monthlyReportSent)     allRep++;
    allPending += (r.tasks||[]).filter(t=>t.status!=='done'&&t.status!=='cancelled').length;
  });
  const n = brands.length;
  const fmtM = month ? new Date(month+'-01').toLocaleDateString('en-GB',{month:'long',year:'numeric'}) : '';

  return (
    <div>
      <div style={{ marginBottom:28 }}>
        <h1 className="page-title">Good morning 👋</h1>
        <p className="page-sub">{fmtM} — {n} brands across {managers.length} managers</p>
      </div>

      <div className="stat-strip">
        {[
          { val: `${allCpD}/${n}`, lbl:'Plans → Designer', cls: allCpD===n?'ok':'warn' },
          { val: `${allCpC}/${n}`, lbl:'Plans → Client',   cls: allCpC===n?'ok':'warn' },
          { val: `${allRep}/${n}`, lbl:'Reports sent',     cls: allRep===n?'ok':'warn' },
          { val: allPending,       lbl:'Open tasks',        cls: allPending>5?'warn':allPending>0?'warn':'ok' },
        ].map((s,i) => (
          <motion.div key={i} className="stat-card" initial={{opacity:0,scale:.95}} animate={{opacity:1,scale:1}} transition={{delay:i*.05,duration:.25}}>
            <div className={`sc-val ${s.cls}`}>{s.val}</div>
            <div className="sc-label">{s.lbl}</div>
          </motion.div>
        ))}
      </div>

      <div className="sec-divider">Brand managers</div>
      <motion.div className="managers-grid" variants={container} initial="initial" animate="animate">
        {managers.map(mgr => {
          const s = getMgrStats(mgr, brands, getMonthRecord, month);
          return (
            <motion.div
              key={mgr.id} variants={item}
              className="mgr-card"
              style={{ '--mgr-color': mgr.color }}
              whileHover={{ y:-3, borderColor: mgr.color+'60', transition:{duration:.2} }}
              whileTap={{ scale:.98 }}
              onClick={() => navigate('manager', { manager: mgr.id })}
            >
              <div style={{ position:'absolute', top:0, left:0, right:0, height:3, background:mgr.color, borderRadius:'var(--r-lg) var(--r-lg) 0 0' }} />
              {s.pending > 0 && <div className="mgr-pending-badge">{s.pending} open</div>}
              <div className="mgr-card-top">
                <div className="mgr-avatar" style={{ background: mgr.color }}>
                  {mgr.name.slice(0,2).toUpperCase()}
                </div>
                <div>
                  <div className="mgr-name">{mgr.name}</div>
                  <div className="mgr-count">{s.n} brand{s.n!==1?'s':''}</div>
                </div>
              </div>
              <div className="mgr-kpis">
                {[
                  { val:`${s.cpD}/${s.n}`, lbl:'→ Designer', r:s.cpDRate },
                  { val:`${s.cpC}/${s.n}`, lbl:'→ Client',   r:s.cpCRate },
                  { val:`${s.rep}/${s.n}`, lbl:'Reports',    r:s.repRate },
                  { val: s.postRate!==null?s.postRate+'%':'—', lbl:'Posts', r:s.postRate },
                ].map((k,i) => (
                  <div key={i} className="mkpi">
                    <div className={`mkpi-val ${rateClass(k.r)}`}>{k.val}</div>
                    <div className="mkpi-lbl">{k.lbl}</div>
                  </div>
                ))}
              </div>
            </motion.div>
          );
        })}
      </motion.div>
    </div>
  );
}
